import { VF_SUB_SECTION_TITLE1 } from 'AppSrc/core/components/forms/form-base-components/v-f-section-header';

const fieldId = 'outage-window-title';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Outage Window',
};

const OwTitle = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE1,
};

export { OwTitle };
